import { Faq } from "./Faq";
import { Hero } from "./Hero";
import { HowItWorks } from "./HowItWorks";
import { Industries } from "./Industries";
import { Plans } from "./Plans";
import { Principles } from "./Principles";
import { SiteFooter } from "./SiteFooter";
import { SiteNav } from "./SiteNav";

/**
 * Design read: trust-first B2B2C landing for Korean small-business owners and app or shop
 * operators, calm plain-spoken language, Wanted DS with restrained CSS motion.
 * Dials: VARIANCE 5, MOTION 3, DENSITY 4.
 */
export function LandingPage() {
  return (
    <div className="min-h-dvh bg-background-normal text-label-normal">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-30 focus:rounded-md focus:bg-background-elevated focus:px-4 focus:py-3 focus:shadow-strong"
      >
        본문으로 건너뛰기
      </a>
      <SiteNav />
      <main id="main">
        <Hero />
        <HowItWorks />
        <Principles />
        <Industries />
        <Plans />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}
